'use strict';

import type { IndAddress } from '../../Entities/Ind/IndAddress';
import { EntityCollection } from '../EntityCollection';

export class IndAddressCollection extends EntityCollection<IndAddress> {}
